export const getVariant = (id: string, variants: Record<number, string>) => {
  if (!window.google_optimize) return 'original';

  const variant = window.google_optimize.get(id);
  if (variant === 0 || !variants[variant]) return 'original';

  return variants[variant];
};
